import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import * as Objects from '@core/objects';
import { UrlService } from '@core/services/url/url.service';

@Injectable({
    providedIn: 'root'
})
export class AIRequests {

    private readonly prefix = "/kpi-assistant/questions"; // TODO change to a project url

    constructor(private http: HttpClient, private urlSrv: UrlService,
    ) { }

    public warm$ = (): Observable<Objects.AIAnswer> =>
        this.http.get<Objects.AIAnswer>(this.urlSrv.build(this.prefix));

    public send$ = (questionContent: string): Observable<Objects.AIQuestionResponse> => {
        let payload = { question: questionContent };
        return this.http.post<Objects.AIQuestionResponse>(this.urlSrv.build(this.prefix), payload, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
    }

    public fetchAnswer$ = (id: string): Observable<Objects.AIAnswer> =>
        this.http.get<Objects.AIAnswer>(this.urlSrv.build(this.prefix + "/" + id));



}